export default function Contact() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            有任何韩漫相关问题或合作意向，欢迎与我们取得联系
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/60">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
            <div className="p-4">
              <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center mb-3">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">投稿邮箱</h3>
              <p className="text-xs text-foreground-500">submit@hanmanzhijia.com</p>
            </div>

            <div className="p-4">
              <div className="w-12 h-12 mx-auto rounded-xl bg-accent-100 flex items-center justify-center mb-3">
                <i className="ri-chat-smile-2-line text-xl text-accent-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">读者交流群</h3>
              <p className="text-xs text-foreground-500">QQ群：88888888</p>
            </div>

            <div className="p-4">
              <div className="w-12 h-12 mx-auto rounded-xl bg-secondary-100 flex items-center justify-center mb-3">
                <i className="ri-briefcase-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">bd@hanmanzhijia.com</p>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-background-200/60">
            <p className="text-center text-xs text-foreground-400">
              工作时间：周一至周五 9:00-18:00 · 通常在24小时内回复
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}